/* ============================================================
   ResetRx — partner landing page behaviour (sections/rx-partner.liquid)
   1. partner context: utm_source → eyebrow + Klaviyo $source; promo code
      (allow-listed) → offer lines + carried to checkout as ?discount=
   2. sticky bar + plan tabs (entrances and press/hover motion come from
      the site-wide layer, resetrx-motion.{css,js})
   3. membership: segmented plan toggle + checkout (same cart flow as rx-start)
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-rxp]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---- 1 · partner context ------------------------------------------ */
  var params = new URLSearchParams(window.location.search);
  function stored(key, fresh) {
    try {
      if (fresh) { sessionStorage.setItem(key, fresh); return fresh; }
      return sessionStorage.getItem(key) || '';
    } catch (e) { return fresh || ''; }
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  var allowed = (root.getAttribute('data-allowed-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  var source = stored('rx_partner_source', (params.get('utm_source') || '').toLowerCase().replace(/[^a-z0-9_-]/g, ''));
  var code = (params.get('code') || cookie('discount_code') || '').toUpperCase().trim();
  if (allowed.indexOf(code) === -1) code = '';
  code = stored('rx_partner_code', code) || root.getAttribute('data-default-code') || '';
  // offer window: once the codes expire in Shopify, stop promising the offer
  var offerEnds = Date.parse(root.getAttribute('data-offer-ends') || '');
  if (offerEnds && Date.now() > offerEnds) code = '';

  if (source) {
    (root.getAttribute('data-source-labels') || '').split('\n').forEach(function (line) {
      var i = line.indexOf('=');
      if (i > 0 && line.slice(0, i).trim().toLowerCase() === source) {
        var eb = root.querySelector('[data-rxp-eyebrow]');
        if (eb) eb.textContent = line.slice(i + 1).trim();
      }
    });
    var src = root.querySelector('[data-rxp-source]');
    if (src) src.value = src.getAttribute('data-prefix') + '-' + source;
  }
  if (code) {
    all('[data-rxp-code]').forEach(function (el) { el.textContent = code; });
    all('[data-rxp-offer], [data-rxp-offer-sub]').forEach(function (el) { el.hidden = false; });
    var note0 = root.querySelector('[data-rxp-bar-note]');
    if (note0) note0.textContent = '50% off with ' + code;
  }

  /* ---- 2 · sticky bar + plan tabs -------------------------------------
     Entrances (headline mask, scroll reveals) come from the site-wide motion
     layer, assets/resetrx-motion.{css,js}, since 2026-09-29. */

  var bar = root.querySelector('[data-rxp-bar]');
  var barBtn = root.querySelector('[data-rxp-bar-btn]');
  var barTitle = root.querySelector('[data-rxp-bar-title]');
  var barNote = root.querySelector('[data-rxp-bar-note]');
  var barLabel = root.querySelector('[data-rxp-bar-label]');
  var barDefaultNote = barNote ? barNote.textContent : '';
  var hero = root.querySelector('.rxp-hero');
  var member = root.querySelector('#rxp-membership');
  var segEl = root.querySelector('[data-rxp-seg]');
  var barMode = 'guide';
  var ticking = false;

  function activePlan() { return root.querySelector('[data-rxp-plan]:not([hidden])'); }
  function ctaVisible() {
    var p = activePlan();
    var c = p && p.querySelector('[data-rxp-plan-cta]');
    if (!c) return false;
    var r = c.getBoundingClientRect();
    return r.top < window.innerHeight - 70 && r.bottom > 0;
  }
  function paintBar() {
    if (!bar) return;
    var p = activePlan();
    if (barMode === 'buy' && p) {
      var dual = !!p.getAttribute('data-selling-plan-annual');
      barTitle.textContent = p.getAttribute('data-plan-name');
      barNote.textContent = (code && p.getAttribute('data-bar-offer')) || p.getAttribute('data-bar-note') || '';
      barLabel.textContent = dual ? 'Choose billing' : 'Start ' + p.getAttribute('data-plan-name');
    } else {
      barTitle.textContent = 'ResetRx membership';
      barNote.textContent = barDefaultNote;
      barLabel.textContent = 'Get started';
    }
  }
  function onScroll() {
    ticking = false;
    var y = window.pageYOffset;
    if (segEl) segEl.classList.toggle('is-stuck', segEl.getBoundingClientRect().top <= (parseFloat(getComputedStyle(segEl).top) || 10) + 1);
    if (bar && hero && member) {
      var r = member.getBoundingClientRect();
      var inMember = r.top < window.innerHeight * 0.6 && r.bottom > window.innerHeight * 0.5;
      var mode = inMember ? 'buy' : 'guide';
      if (mode !== barMode) { barMode = mode; paintBar(); }
      var on = y > hero.offsetHeight * 0.7 && !(inMember && ctaVisible());
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barBtn) barBtn.tabIndex = on ? 0 : -1;
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });

  function scrollToEl(el, offset) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - (offset || 0);
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }
  if (barBtn) {
    barBtn.addEventListener('click', function () {
      var p = activePlan();
      if (barMode !== 'buy' || !p) { scrollToEl(member, 0); return; }
      if (p.getAttribute('data-selling-plan-annual')) { scrollToEl(p.querySelector('[data-rxp-plan-cta]'), window.innerHeight * 0.45); return; }
      var buy = p.querySelector('[data-rxp-buy]');
      if (buy) buy.click();
    });
  }

  // in-page anchors: smooth scroll without fighting reduced motion
  all('a[href^="#rxp-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = root.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---- 3 · membership ------------------------------------------------ */
  var seg = root.querySelector('.rxp-seg');
  var tabs = all('[data-rxp-tab]');
  var plans = all('[data-rxp-plan]');
  function select(index) {
    index = String(index);
    if (seg) seg.setAttribute('data-active', index);
    tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-plan-index') === index ? 'true' : 'false'); });
    plans.forEach(function (p) { p.hidden = p.getAttribute('data-plan-index') !== index; });
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var wasStuck = segEl && segEl.classList.contains('is-stuck');
      select(t.getAttribute('data-plan-index'));
      paintBar();
      var p = activePlan();
      if (wasStuck && p) scrollToEl(p, (segEl.offsetHeight || 60) + 26);
      onScroll();
    });
  });
  var featured = root.querySelector('.rxp-plan--featured') || plans[0];
  if (featured) select(featured.getAttribute('data-plan-index'));
  onScroll();

  all('[data-rxp-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var plan = btn.closest('[data-rxp-plan]');
      if (!plan) return;
      var variantId = plan.getAttribute('data-variant-id');
      var wantAnnual = btn.getAttribute('data-rxp-cadence') === 'annual';
      var sellingPlanId = (wantAnnual && plan.getAttribute('data-selling-plan-annual'))
        ? plan.getAttribute('data-selling-plan-annual')
        : plan.getAttribute('data-selling-plan-monthly');
      if (!variantId) { alert('This plan is not yet configured for checkout. Please contact support.'); return; }
      var labelEl = btn.querySelector('[data-rxp-buy-label]');
      var original = labelEl ? labelEl.textContent : '';
      btn.disabled = true;
      if (labelEl) labelEl.textContent = 'Loading…';
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          var body = { id: parseInt(variantId, 10), quantity: 1 };
          if (sellingPlanId) body.selling_plan = parseInt(sellingPlanId, 10);
          if (source) body.properties = { _source: source };
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        })
        .then(function (resp) {
          if (!resp.ok) throw new Error('cart/add failed: ' + resp.status);
          window.location = '/checkout?skip_shop_pay=true' + (code ? '&discount=' + encodeURIComponent(code) : '');
        })
        .catch(function (err) {
          console.error('[rx-partner] checkout error', err);
          btn.disabled = false;
          if (labelEl) labelEl.textContent = original;
          alert('Something went wrong starting your membership. Please try again, or contact support if it persists.');
        });
    });
  });
})();
